import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from "react-bootstrap";
import SubmitButton from "../Main/Dashboard/components/SubmitButton";
import { useNavigate, useParams } from "react-router-dom";
import columnConfig from "../Main/Dashboard/columns";
import { Api } from "../../../helpers/Api";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { connect } from "react-redux";
import { Validation } from "../../../helpers/Validation";
import { renderField } from "../Main/Form/form";
import LoadingSpinner from '../Components/Spinner/LoadingSpinner';

const ProgramForm = ({ user, ...props }) => {
    const params = useParams();
    params.path = 'templates';
    const [data, setData] = useState({
        resource_persons: [{ name: "", email: "", designation: "", description: "", }],
        data: [], Newss: [{ url: "" }], publish:false, qr: true, event_Is:"Individual"
    });


    // Add More Field
    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const d = { ...data };
        d.resource_persons[index][name] = value;
        setData(d)
    };

    // handle click event of the Remove button
    const handleRemoveClick = index => {
        const d = { ...data };
        d.resource_persons.splice(index, 1);
        setData(d)
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        const d = { ...data };
        d.resource_persons.push({ name: "", email: "", designation: "", description: "", });
        setData(d)
    };
    // const [resourcePerson, setResourcePerson] = useState([
    //     { ...RESOURCE_PERSON_ITEM },
    // ]);

    let config = columnConfig[params.path];
    const navigate = useNavigate();
    const [state, setState] = useState({
        loading: true,
        error: null,
        config: config,
        page: 1,
        limit: 20000,
        total: 0,
        show: false,
    });
    const [errors, setErrors] = useState([]);

    const fetchOptions = async (c) => {
        let o = await Api.call(`${c.url}`);
        let options = [];
        o.map(object => {
            options.push({ label: object[c.label], value: object[c.key], object });
        })
        return options;
    }

    useEffect(async () => {
        const config = { ...state.config };

        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].updateOptions) {
                config.form[i].options = config.form[i].updateOptions(config.form[i].allOptions, data);
            }
        }
        setState((s) => {
            return { ...s, config }
        })
    }, [data])

    useEffect(async () => {
        if (!user) {
            return;
        }
        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].fetchOptions) {
                let options = await fetchOptions(config.form[i].fetchOptions);
                if (!config.form[i].updateOptions) {
                    config.form[i].options = options;
                }
                config.form[i].allOptions = options;
            }
        }

        setState((s) => {
            return { ...s, config }
        })
    }, [config, user]);

    const loadData = (id) => {
        if (id =='new') {
            setTimeout(() => {
            setData({
                resource_persons: [{ name: "", email: "", designation: "", description: "", }],
                data: [], Newss: [{ url: "" }], publish:false, qr: true, event_Is:"Individual"
            });
            updateState({ loading: false });
            }, 5000)
        }
        else{
        Api.call(`/${state.config.url}/${id}`).then(post => {

            if (!post.resource_persons) {
                post.resource_persons = [{ name: "", email: "", designation: "", description: "", }]
            }
            setTimeout(() => {
                setData(post);
                updateState({ loading: false });
            }, 5000)
        }).catch(console.log).finally(() => {
        });
    }
    };

    useEffect(() => {
       console.log(data)

    }, [data])

    useEffect(() => {
        if (params.id) {
            loadData(params.id)
        }
    }, [params.id])

    const validate = () => {
        let errors = {};
        state.config.form.map((field) => {
            if (field.condition && data[field.condition.key] !== field.condition.value) {
                return;
            }
            if (field.required && (!data[field.key] || data[field.key] === "Please Select")) {
                errors[field.key] = `${field.name} is required`;
            }
            if (field.validations) {
                let validate;
                
                if (field.validations[0].compareWith) {
                    validate = Validation.Ragularexpression(data[field.key], field.validations, data[field.validations[0].compareWith])       
                }
                else {
                    validate = Validation.Ragularexpression(data[field.key], field.validations)
                }
                if (validate && validate[0]) {
                    // let a = Validation.Ragularexpression(data[field.key], field.validations);
                    errors[field.key] = `${validate[0]}`;
                }

            }
        });
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const submit = (e) => {
        e.preventDefault();
        if (!validate()) { 
            return;
        }
        if (data.id) {
            update();
        } else {
            create();
        }
    };

    const updateState = (obj) => {
        setState(s => {
            Object.keys(obj).forEach(key => {
                s[key] = obj[key];
            });
            return s;
        });
    }

    const publish = () =>{
        if(data.publish == false) data.publish = true;
        
        else
        {
            if(data?.registrations.length != 0){
                window.alert(`There is ${data.registrations.length} registratio`)
                    return;
            }
            else 
            {
                if (!window.confirm('Are you sure you want to unpublished this event?')) {
                    return;
                }
            }
            data.publish = false;
        } 

        if (!validate()) {
            return;
        }
        if (data.id) {
            update(true);
        } else {
            create(true);
        }
    };

    const update = (upcomming=false) => {
        updateState({ loading: true });
        Api.call(`/${state.config.url}/${data.id}`, "PUT", data).then(post => {
            setData(post)
            if(upcomming == true){
                navigate(`/${state.config.cancel_url}`)
            }
            else if(data["event_Is"] === "Parent"){
                navigate(`/UpCommingEvents/0`);
            }
            else {
                navigate(`/eventTemplates/${post.id}`);
            }
        }).catch(console.log).finally(() => {
            updateState({ loading: false });
        })
    };
    const create = (upcomming=false) => {
        updateState({ loading: true });
        data.owner = user.user;
        Api.call(`/${state.config.url}`, "POST", data).then(post => {
            setData(post);
            console.log(post)
            if(upcomming === true){
                navigate(`/${state.config.cancel_url}`)
            }
            else if(data["event_Is"] === "Parent"){
                navigate(`/UpCommingEvents/0`);
            }
            else {
                navigate(`/eventTemplates/${post.id}`);
            }
        }).catch(console.log).finally(() => {
            updateState({ loading: false });
        })
    };
    const onChange = (key, value, index = null) => {
        console.log({ key, value })

        let d = { ...data };
        d[key] = value;
        setData(d)
    };


    return state.loading ? <LoadingSpinner /> : <div className="right_container">
        <div className="dashboard">
            <div className='inner-content'>
            <div className="reports-header">
                    <div><h4>{params.id !== "new" ? 'Edit Event' : 'Add Event'}</h4></div>
                    <div><a className='btn btn-secondary btn-sm' target='_blank' href={`https://eventscu.s3.ap-south-1.amazonaws.com/Required_Report_IIC_442ecdc0a3.pdf`} >IIC Format(from 01/July/2026)</a>
                         <a className='btn btn-secondary btn-sm' target='_blank' href={`${Api.base_url1}/uploads/Standard_Format_IIC_Activity_WEF_01_September_2022_c4d31c7c37.docx`} style={{ marginLeft: 20 }} >IIC Format(Till 30/June/2026)</a>
                         <a className='btn btn-secondary btn-sm' target='_blank' href={`${Api.base_url1}/uploads/Guidelines_for_RISE_Events_1_0_5_ebe3ac73a6.docx`} style={{ marginLeft: 20, marginRight: 10 }}>RISE-EVENT Format</a>
                    </div></div>
                <div className='mt-3 commen-form'>

                    {state.config.renderForm ?
                        state.config.renderForm() :
                        <Form autoComplete={'off'} onSubmit={submit}>
                            <Row>
                                {state.config.form.map((field) => {
                                    if (field.render) {
                                        let d = data[field.key];
                                        if (!d) {
                                            d = {};
                                        }
                                        return field.render(d, (d) => {
                                            onChange(field.key, d)
                                        })
                                    }

                                    return renderField(field,errors,data,onChange)
                                })}
                            </Row>
                            <div className='resource-person'>
                                <h4>Resource Persons</h4>
                                <div className='resource-person-form'>
                                    {data.resource_persons.map((x, i) => {
                                        return (
                                            <Row>
                                                <Col md={3}>
                                                    <Form.Group >
                                                        <Form.Label style={{ color: "white" }}>Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name='name'
                                                            value={x.name}
                                                            onChange={e => handleInputChange(e, i)}
                                                            placeholder="Name"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group >
                                                        <Form.Label style={{ color: "white" }}>Email</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name='email'
                                                            value={x.email}
                                                            onChange={e => handleInputChange(e, i)}
                                                            placeholder="Email"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group >
                                                        <Form.Label style={{ color: "white" }}>Designation</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name='designation'
                                                            value={x.designation}
                                                            onChange={e => handleInputChange(e, i)}
                                                            placeholder="Designation"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group >
                                                        <Form.Label style={{ color: "white" }}>Affiliation/Name of Organization</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name='description'
                                                            value={x.description}
                                                            onChange={e => handleInputChange(e, i)}
                                                            placeholder="Description"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <div className="add-more-field">
                                                    {data.resource_persons.length !== 1 && <button
                                                        onClick={() => handleRemoveClick(i)}>
                                                        <img src='../../../../images/remove-icon.png' alt='RemoveIcon' />
                                                        Remove</button>}
                                                    {data.resource_persons.length - 1 === i && <button onClick={handleAddClick}>
                                                        <img src='../../../../images/add-more.png' alt='AddIcon' />
                                                        Add
                                                    </button>}
                                                </div>
                                            </Row>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className='Form-buttons'>
                                <button type="button" onClick={() => {
                                    navigate(`/${state.config.cancel_url}`)
                                }} className='cancel'>Cancel</button>

                                <button disabled={state.loading} type="button" onClick={() => {
                                   publish()   
                                }} className='cancel'>{data.publish ? "UnPublish":"Publish"}</button>

                                {user?.user?.role == 0 && <button disabled={data.publish} type="button" onClick={() => {
                                }} className='cancel'>Publish On Chitkara Desktop</button>}

                                <SubmitButton label={params.id === "new" ? (state.config.submitButtonText || 'Submit') : 'Update'}
                                    loading={state.loading} />
                            </div>
                        </Form>
                    }
                </div>
            </div>
        </div>
    </div>
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgramForm)
